const PictViewClass = require('pict-view');
const ComprehensionProcessor = require('headlight-comprehension-processor');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class TestInstanceWizard extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.wizardStep = 1;
		this.finalStep = 3;
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
		this.SelectedIDTest = 0;
		this.testsToCreate = [];
		this.documentList = [];
		this.formsToCreate = [];
		this.decoratedDocumentRecords = [];
		/** @type {?Function} */
		this.onTestsCreated = null;
	}

	async continue()
	{
		const continueButton = document.getElementById('TestInstanceWizard-Continue');
		continueButton.classList.add('is-loading');

		switch (this.wizardStep)
		{
			case 1:
				if (!this.testsToCreate.length)
				{
					this.pict.views.HeadlightPanels.toast({
						message: 'No Tests were selected.',
						type: 'is-danger',
					});
					continueButton.classList.remove('is-loading');
					return;
				}
				const foundManifests = [];
				const allSatisfiedIDTests = this.formsToCreate.flatMap((f) => f.SatisfiedIDTests || []);
				const testsForForms = allSatisfiedIDTests.length > 0
					? await this.pict.providers.TestInstanceProvider.getTestsByIDs(allSatisfiedIDTests)
					: [];
				const hashMap = {};
				testsForForms.forEach(t =>
				{
					hashMap[t.Hash] = t;
				});
				for (let f of this.formsToCreate)
				{
					if (f.IDReportNamedInstance)
					{
						const satisfiedHashes = f.SatisfiedTestHashes || [f.TestHash];
						this.decoratedDocumentRecords.push(
							{
								Index: this.decoratedDocumentRecords.length,
								Name: `${ satisfiedHashes.join(', ') } for Sample ${ this.AppData.SampleDetails.QRCode }`,
								DocumentType: f.Hash,
								Tests: satisfiedHashes.map((h) => hashMap[h]).filter(Boolean),
								FormattedTests: [f],
								Type: f.Name
							}
						);
						if (f.LabName)
						{
							const rec = this.decoratedDocumentRecords[this.decoratedDocumentRecords.length - 1];
							rec.Name = `${rec.Name} in ${f.LabName}`;
						}
					}
					else
					{
						foundManifests.push(f);
					}
				}
				if (foundManifests.length)
				{
					const rnis = await this.pict.services.MaterialsFormManager._getAvailableRNIs(this.AppData.SampleDetails?.IDProject);
					let foundGenericMaterialForm = null;
					for (let r of rnis)
					{
						//if (r.Options.TidingsData.Type === 'materials-form' && !foundGenericMaterialForm)
						if (r.GUIDReportNamedInstance == 'LADOTD-LIMS-ContainerForm' && !foundGenericMaterialForm)
						{
							foundGenericMaterialForm = r;
						}
					}
					if (foundGenericMaterialForm)
					{
						const foundManifestsByLab = {};
						for (let f of foundManifests)
						{
							const labName = f.LabName || '';
							if (!foundManifestsByLab[labName])
							{
								foundManifestsByLab[labName] = [];
							}
							foundManifestsByLab[labName].push(f);
						}
						for (const labName of Object.keys(foundManifestsByLab))
						{
							const labManifests = foundManifestsByLab[labName];
							this.decoratedDocumentRecords.push(
								{
									Index: this.decoratedDocumentRecords.length,
									Name: `${ labManifests.map(f => f.TestHash).join(', ') } for Sample ${ this.AppData.SampleDetails.QRCode }`,
									DocumentType: foundGenericMaterialForm.Hash,
									Tests: [...labManifests.map(f => hashMap[f.TestHash])],
									FormattedTests: labManifests,
									Type: foundGenericMaterialForm.Name
								}
							);
							if (labName)
							{
								const rec = this.decoratedDocumentRecords[this.decoratedDocumentRecords.length - 1];
								rec.Name = `${rec.Name} in ${labName}`;
							}
						}
					}
				}
				break;
			case 2:
				const docsToPush = [];
				const comprehensionsToPush = [];
				for (const d of this.decoratedDocumentRecords)
				{
					const tempDoc = {
						Name: d.Name,
						DocumentType: d.DocumentType,
						IDProject: this.AppData.SampleDetails?.IDProject,
						Form: 1
					};
					for (const f of d.FormattedTests)
					{
						if (f.LabID > 0 && !f.TestInstance)
						{
							f.TestInstance = { IDProject: this.AppData.SampleDetails?.IDProject, IDLab: f.LabID };
						}
					}
					comprehensionsToPush.push(await this.pict.services.MaterialsFormManager.applyMaterialTestsToDocumentRecord(d.FormattedTests, tempDoc, this.AppData.SampleDetails?.GUIDSample));
					docsToPush.push(tempDoc);
				}
				console.log('Documents to push: ', docsToPush);
				console.log('Comprehensions to push: ', comprehensionsToPush);
				this.uploadData(docsToPush, comprehensionsToPush);
				break;
			case 3:
				break;
			default:
				this.pict.log.warn(`Step in TestInstance creation was not found, this should not happen.`);
				break;
		}
		this.wizardStep += 1;

		this.renderAsync(()=>
		{
			const steps = document.querySelectorAll('#TestInstanceWizard-Steps-List li');
			steps.forEach((step, i) =>
			{
				if (i + 1 === this.wizardStep - 1)
				{
					step.classList.add('prev-active');
				}
				else
				{
					step.classList.remove('prev-active');
				}
				if (i + 1 === this.wizardStep)
				{
					step.classList.add('is-active');
				}
				else
				{
					step.classList.remove('is-active');
				}
			});
			const stepBodies = document.querySelectorAll('#TestInstanceWizard-Body-Pane > div');
			stepBodies.forEach((stepBody, i) =>
			{
				if (i + 1 === this.wizardStep)
				{
					stepBody.classList.add('is-active');
				}
				else
				{
					stepBody.classList.remove('is-active');
				}
			});
			if (this.wizardStep === this.finalStep)
			{
				document.getElementById('TestInstanceWizard-Continue').classList.add('is-hidden');
			}
			document.getElementById('TestInstanceWizard-Continue').classList.remove('is-loading');
		});
	}

	updateDocumentName(index)
	{
		// @ts-ignore
		this.decoratedDocumentRecords[index].Name = document.getElementById(`DocumentCreate-Entry-Name-${ index }`)?.value;
	}

	async uploadData(documents, comprehensions)
	{
		this.fable.addServiceType('ComprehensionProcessor', ComprehensionProcessor);

		/** @type {ComprehensionProcessor} */
		const processor = this.fable.instantiateServiceProviderWithoutRegistration('ComprehensionProcessor', this.options);
		for (let d of documents)
		{
			await this.pict.providers.DocumentProvider.createDocument(d, true);
		}
		for (let c of comprehensions)
		{
			await new Promise((resolve, reject) => 
			{
				processor.integrateComprehension(c, () =>
				{
					resolve();
				});
			});
		}
		if (this.onTestsCreated)
		{
			const fOnTestsCreated = this.onTestsCreated;
			this.onTestsCreated = null;
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			fOnTestsCreated();
		}
		else if (this.pict.views.LIMSSampleRecordView)
		{
			this.pict.views.LIMSSampleRecordView.renderAsync(()=>
			{
				this.pict.views.LIMSSampleRecordView.toggleTabContent({ currentTarget: document.getElementById('LIMSSampleRecordPanel-TestInstance-Tab') }, 'LIMSSampleRecordPanel-TestInstances');
				this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			});
		}
		else
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		}
	}

	/**
	 * Toggles the disabled attribute on/off for the passed in elements
	 * @param {Array.<{id:string, title:string}>} elements - {id: id of the element to target, title: tooltip when not disabled }
	 * @param {string} disabledText (optional) - tooltip to display when element is disabled
	 */
	toggleDisabled(elements, disabledText)
	{
		for (const [ key ] of Object.entries(elements))
		{
			const element = elements[key];
			if (!element.hasOwnProperty('id') )
			{
				continue;
			}
			const el = document.getElementById(element.id);

			if (!el)
			{
				continue;
			}

			if (el.hasAttribute('disabled'))
			{
				this.pict.ContentAssignment.removeAttribute(`#${element.id}`, 'disabled');
				if (element.title && typeof element.title === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', element.title );
				}
			}
			else
			{
				this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'disabled', 'disabled');
				if (typeof disabledText === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', disabledText);
				}
			}
		};
	}

	/**
	 * This method resets the state of the Wizard Panel view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetTestInstanceWizardView()
	{
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
		this.SelectedIDTest = 0;
		this.documentList = [];
		this.testsToCreate = [];
		this.formsToCreate = [];
		this.decoratedDocumentRecords = [];
		this.wizardStep = 1;
		this.setSampleData();
		this.pict.HeadlightPanels.leftPanelCustomWidth(75);
		this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.rightPanelHide();
	}

	setSampleData()
	{
		for (const d of (this.AppData.ActiveLIMSSampleDocuments || []))
		{
			if (!d.Locked)
			{
				this.documentList.push(d);
			}
		}
	}

	async addDefaultTests()
	{
		let sampleLabIDs = await this.pict.services.MaterialsFormManager.getSampleLabIDs(this.AppData.SampleDetails?.IDSample);
		if (!Array.isArray(sampleLabIDs) || sampleLabIDs.length < 1)
		{
			sampleLabIDs = null;
		}
		// The sample's line items are its SampleLineItemJoins (Sample.IDLineItem is not used).
		const sampleLineItemIDs = await this.pict.services.MaterialsFormManager.getSampleLineItemIDs(this.AppData.SampleDetails?.IDSample);
		const defaults = await this.pict.services.MaterialsFormManager.getMaterialTestDefaults(this.AppData.SampleDetails?.IDMaterial, this.AppData.SampleDetails?.IDProject, this.AppData.SampleDetails?.MaterialType, sampleLabIDs, undefined, sampleLineItemIDs);
		console.log('Found defaults: ', defaults);
		if (defaults.length)
		{
			const allSatisfiedIDTests = defaults.flatMap((f) => f.SatisfiedIDTests || []);
			const defaultTests = allSatisfiedIDTests.length > 0
				? await this.pict.providers.TestInstanceProvider.getTestsByIDs(allSatisfiedIDTests)
				: [];
			this.addTests(defaultTests.map(t => { return { IDTest: t.IDTest } }));
			this.addForms(defaults);
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({
				message: `No Default Tests found for this Sample.`,
				type: 'is-warning',
			});
		}
	}

	/**
	 * The lab a test added by hand routes to: the sample's default routing when it covers the test, otherwise
	 * the sample's first lab, which is where the concierge falls back to.
	 * @param {number} pIDTest - The test being added
	 * @return {Promise<{ LabID: number, LabName: string }>} LabID is 0 when nothing resolves
	 */
	async getLabForTest(pIDTest)
	{
		const tmpManager = this.pict.services.MaterialsFormManager;
		let tmpSampleLabIDs = await tmpManager.getSampleLabIDs(this.AppData.SampleDetails?.IDSample);
		if (!Array.isArray(tmpSampleLabIDs) || tmpSampleLabIDs.length < 1)
		{
			tmpSampleLabIDs = null;
		}
		const tmpSampleLineItemIDs = await tmpManager.getSampleLineItemIDs(this.AppData.SampleDetails?.IDSample);
		const tmpDefaults = await tmpManager.getMaterialTestDefaults(this.AppData.SampleDetails?.IDMaterial, this.AppData.SampleDetails?.IDProject, this.AppData.SampleDetails?.MaterialType, tmpSampleLabIDs, undefined, tmpSampleLineItemIDs);
		const tmpDefault = tmpDefaults.find((pDefault) => pDefault.LabID > 0 && (pDefault.SatisfiedIDTests || []).includes(pIDTest));
		if (tmpDefault)
		{
			return { LabID: tmpDefault.LabID, LabName: tmpDefault.LabName || '' };
		}
		return { LabID: (tmpSampleLabIDs && tmpSampleLabIDs[0]) || 0, LabName: '' };
	}

	async addActiveTest()
	{
		if (!this.SelectedIDTest)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No Test was selected to add.',
				type: 'is-danger',
			});
			return;
		}
		const tempForm = await this.pict.services.MaterialsFormManager.getTestDefinitionForTestID(this.SelectedIDTest, this.AppData.SampleDetails?.IDProject, this.AppData.SampleDetails?.IDMaterial);
		if (tempForm)
		{
			// @ts-ignore
			const tmpIDTest = parseInt(this.SelectedIDTest);
			const tmpLab = await this.getLabForTest(tmpIDTest);
			if (!(tmpLab.LabID > 0))
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'No Lab was found for this Test, so it will not route to a Lab.',
					type: 'is-warning',
				});
			}
			this.addTests([{ IDTest: tmpIDTest }]);
			this.addForms([Object.assign({ }, tempForm, tmpLab)]);
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No Form is available for this Test.',
				type: 'is-warning',
			});
		}
	}

	/**
	 * Open the wizard for the sample in AppData.SampleDetails.
	 * @param {Object} [pOptions]
	 * @param {Function} [pOptions.onTestsCreated] - Called once the tests and their documents are saved, instead of
	 * 	refreshing the legacy LIMS sample view.
	 */
	openTestInstanceWizard(pOptions)
	{
		this.resetTestInstanceWizardView();
		this.onTestsCreated = (pOptions && (typeof pOptions.onTestsCreated === 'function')) ? pOptions.onTestsCreated : null;
		this.pict.views.HeadlightPanels.handlePanelToggle('TestInstanceWizard', 'open');
	}

	async addTests(testArray)
	{
		this.testsToCreate = this.testsToCreate.concat(testArray).sort((a, b) => a.IDTest - b.IDTest);
		this.renderAsync();
	}

	addForms(formsArray)
	{
		this.formsToCreate = this.formsToCreate.concat(formsArray).sort((a, b) => a.TestHash - b.TestHash);
	}

	async removeTest(test)
	{
		const tempTests = [];
		
		let found = false;
		for (const t of this.testsToCreate)
		{
			if (test !== t.IDTest || found)
			{
				tempTests.push(t);
			}
			else
			{
				found = true;
			}
		}
		this.testsToCreate = tempTests.sort();
		const tempTest = await this.pict.providers.TestInstanceProvider.getTestByID(test);
		const tempForms = [];
		for (let f of this.formsToCreate)
		{
			const satisfiedHashes = f.SatisfiedTestHashes || [f.TestHash];
			const satisfiedIDTests = f.SatisfiedIDTests || [];
			if (!satisfiedHashes.includes(tempTest.Hash))
			{
				// This form doesn't cover the removed test; keep it as-is
				tempForms.push(f);
			}
			else if (satisfiedHashes.length > 1)
			{
				// This form covers the removed test but also satisfies others; keep it
				// with the removed test's entries pruned from the satisfied lists
				const hashIdx = satisfiedHashes.indexOf(tempTest.Hash);
				f.SatisfiedTestHashes = satisfiedHashes.filter((h) => h !== tempTest.Hash);
				f.SatisfiedIDTests = satisfiedIDTests.filter((id) => id !== test);
				tempForms.push(f);
			}
			// else: form only satisfied this one test — drop it entirely
		}
		this.formsToCreate = tempForms.sort();
		this.renderAsync();
	}

	/**
	 * This method is used to handle the closing of the Wizard panel.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close panel and cancel Test creation?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		},
		null);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		return super.onAfterRender(pRenderable);
	}

	async onAfterRenderAsync(callback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.CurrentUser.CustomerID || 0;

		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Select a Test..',
			ElementID: 'TestInstanceWizard-TestSelector',
			ParentID: 'TestInstanceWizard-Step-1',
			URL: 'Tests',
			IDField: 'IDTest',
			TextField: ['Hash', 'Name'],
		}, () =>
		{
			this.log.info('Select2 Tests initialized');
		});
		callback();
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						},
						{
							field: 'Active',
							comparator: 'EQ',
							target: '1',
						},
						{
							field: '',
							target: '',
							comparator: 'FOP',
						},
						{
							field: 'Standalone',
							comparator: 'EQ',
							target: '1',
						},
						{
							field: 'Injectable',
							comparator: 'EQ',
							target: '1',
							connector: 'OR'
						},
						{
							field: '',
							target: '',
							comparator: 'FCP',
						}],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// Spec-year scope: narrow to tests reachable from the contract's
					// material spec set (via TSMTJ+TSSTJ). Resolver returns null when
					// the gate fails open (no FK, empty stub, no spec infra), which
					// leaves the picker at its default customer-wide filter.
					const tmpAllowedTestIDs = _Pict.providers.SpecScopeResolver?.getAllowedTestIDs?.();
					if (tmpAllowedTestIDs && tmpAllowedTestIDs.size > 0)
					{
						tmpSearchQuery.filters.push({
							field: 'IDTest',
							comparator: 'INN',
							target: Array.from(tmpAllowedTestIDs).join(','),
						});
					}
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FOP',
						});
						tmpSearchQuery.filters.push({
							field: 'Name',
							comparator: 'LK',
							target: params.term,
						});
						tmpSearchQuery.filters.push({
							field: 'Hash',
							comparator: 'LK',
							target: params.term,
							connector: 'OR'
						});
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FCP',
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.TestInstanceWizard.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption, true),
						more: params.term ? data.length === _Pict.views.TestInstanceWizard.CurrentSearchFilters.PageSize : data.length === _Pict.views.TestInstanceWizard.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	handleOnCloseEvent(pEvent)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close panel and cancel Test creation?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.TestInstanceWizard.resetTestInstanceWizardView();
			this.fable.HeadlightPanels.rightPanelResetCustomWidth();
			this.fable.HeadlightPanels.leftPanelResetCustomWidth();
		});
	}

	handleOnPinPanelEvent(pEvent)
	{
		this.pict.views.TestInstanceWizard.toggleDisabled(
		[
			{
				_id: 'TestInstanceWizard-CloseButton',
				title: 'Close panel',
			}
		],
		'Please unpin panel');

		this.pict.views.HeadlightPanels.togglePanelPinState();
	}

	updateIDTest(IDTest)
	{
		this.SelectedIDTest = IDTest;
	}
}

module.exports = TestInstanceWizard;

module.exports.default_configuration =
{
	ViewIdentifier: 'TestInstanceWizard',
	DefaultRenderable: 'TestInstanceWizard',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'TestInstanceWizard-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-TestInstanceWizardPanel" class="panel is-active">
				<p id="HeadlightPanels-TestInstanceWizardPanel-Header" class="panel-heading pr-4">
					<button id="TestInstanceWizard-CloseButton" type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
						onclick="_Pict.views.TestInstanceWizard.handleClosePanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" 
						onclick="_Pict.views.TestInstanceWizard.handleOnPinPanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-TestInstanceWizardPanel-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-TestInstanceWizardPanel-Header-Title" class="mr-3">Add Tests</span>
				</p>
				<div id="HeadlightPanels-TestInstanceWizard-Content">
					{~T:TestInstanceWizard-Content~}
				</div>
			</article>`,
		},
		{
			Hash: 'TestInstanceWizard-Content',
			Template: /*html*/`
			<header class="has-background-text-15">
				<ul id="TestInstanceWizard-Steps-List" class="wizard-list">
					<li id="Wizard-Tag-1" class="wizard-step-1 is-active"><div><span>Select Tests</span></div></li>
					<li id="Wizard-Tag-2" class="wizard-step-2"><div><span>Test Forms</span></div></li>
					<li id="Wizard-Tag-3" class="wizard-step-3 end-block"><div><span>Finalize</span></div></li>
				</ul>
			</header>
			<div id="TestInstanceWizard-Body-Pane">
				<div id="TestInstanceWizard-Step-1" class="wizard-pane is-active">
					{~T:TestInstanceWizard-Wizard-Step-1~}
				</div>
				<div id="TestInstanceWizard-Step-2" class="wizard-pane">
					{~T:TestInstanceWizard-Wizard-Step-2~}
				</div>
				<div id="TestInstanceWizard-Step-3" class="wizard-pane">
					{~T:TestInstanceWizard-Wizard-Step-3~}
				</div>
			</div>
			<div class="buttons is-right" style="width: 50px; position: absolute; top: calc(100% - 60px); right: 0.5rem;">
				<button id="TestInstanceWizard-Continue" title="Continue" onclick="_Pict.views.TestInstanceWizard.continue()" 
				style="float: right; margin: 10px;" class="button is-primary has-text-white has-shadow is-normal"><i class="fas fa-fw fa-square-chevron-right" style="margin-right: 5px;"></i>Continue</button>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Wizard-Step-1',
			Template: /*html*/`
			<div class="container panel-content" id="TestInstanceWizard-Step-1" style="min-width: 100%;">
				<div class="columns px-4 mb-3 mt-3">
					<div class="column">
						{~T:TestInstanceWizard-TestSelector~}
						{~T:TestInstanceWizard-Tab-Tests-Items~}
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Tests-Items',
			Template: /*html*/`
			<div id="TestInstanceWizard-Tab-Tests-Items">
				<style>
					.test-entry-row
					{
						display:flex;
						justify-content: space-between;
					}
					.test-entry
					{
						border-top: 1px solid var(--bulma-border);
						border-bottom: 1px solid var(--bulma-border);
					}
				</style>
				{~TS:TestInstanceWizard-Tab-Test-Item:Context[0].testsToCreate~}
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Test-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4 test-entry">
				<div class="test-entry-row mx-4 my-2" style="flex-grow: 1">
					<div>{~Entity:Test^Record.IDTest^TestInstanceWizard-Entity^~}{~QuickSummary:Test^Record.IDTest~}</div>
					<button type="button" class="is-pulled-right hl-panel-close-button" 
						onclick="_Pict.views.TestInstanceWizard.removeTest({~D:Record.IDTest~})">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Entity',
			Template: /*html*/`{~D:Record.Hash~} {~D:Record.Name~}`,
		},
		{
			Hash: 'TestInstanceWizard-Wizard-Step-2',
			Template: /*html*/`
			<div class="container panel-content" style="min-width: 100%;">
				<div id="TestInstanceWizard-Document-List">
					{~T:TestInstanceWizard-Tab-Documents:Context[0].decoratedDocumentRecords~}
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Wizard-Step-3',
			Template: /*html*/`
			<div class="container panel-content">
				<div class="p-4">
					<div class="columns is-mobile">
						<div class="column has-text-white">
							<style>
								.lds-ring,
								.lds-ring div {
									box-sizing: border-box;
								}
								.lds-ring {
									display: inline-block;
									position: relative;
									width: 80px;
									height: 80px;
								}
								.lds-ring div {
									box-sizing: border-box;
									display: block;
									position: absolute;
									width: 64px;
									height: 64px;
									margin: 8px;
									border: 8px solid currentColor;
									border-radius: 50%;
									animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
									border-color: currentColor transparent transparent transparent;
								}
								.lds-ring div:nth-child(1) {
									animation-delay: -0.45s;
								}
								.lds-ring div:nth-child(2) {
									animation-delay: -0.3s;
								}
								.lds-ring div:nth-child(3) {
									animation-delay: -0.15s;
								}
								@keyframes lds-ring {
									0% {
										transform: rotate(0deg);
									}
									100% {
										transform: rotate(360deg);
									}
								}
							</style>
							<div class="lds-ring wizard-loader" style="color: white;"><div></div><div></div><div></div><div></div></div>
							<div class="is-size-6 has-text-centered" style="color: white; text-wrap: wrap: max-width: 50vw;">Creating Tests and Forms...</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-TestSelector',
			Template: /*html*/`
			<div style="margin-bottom: 10px; display: flex;">
				<div style="width: 100%; max-width: 30%; margin-right: 10px;">
					<div class="field">
						<label class="label block" for="TestInstanceWizard-TestSelector">Select a Test to Add:</label>
						<div class="control select is-fullwidth">
							<select 
								id="TestInstanceWizard-TestSelector" 
								onchange="_Pict.views.TestInstanceWizard.updateIDTest(value)"
							></select>
						</div>
					</div>
				</div>
				<div style="margin-right: 10px;"><label class="label block">&nbsp;</label><button type="button" onclick="_Pict.views.TestInstanceWizard.addActiveTest()" class="button is-primary has-text-white is-normal"><i class="fas fa-fw fa-plus" style="margin-right: 5px;"></i>Add Selected Test</button></div>
				<div><label class="label block">&nbsp;</label><button type="button" onclick="_Pict.views.TestInstanceWizard.addDefaultTests()" class="button is-primary has-text-white is-normal"><i class="fas fa-fw fa-list" style="margin-right: 5px;"></i>Add Default Tests</button></div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents',
			Template: /*html*/`
				{~TIfAbs:TestInstanceWizard-Tab-Documents-Items:Record:Record.length^>^0~}
				{~TIfAbs:TestInstanceWizard-Tab-Documents-Empty:Record:Record.length^<=^0~}
			`
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Empty',
			Template: /*html*/`
			<div class="notification empty-message m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No valid documents found to add this test to.</span>
				</p>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Items',
			Template: /*html*/`
			<div id="TestInstanceWizard-Tab-Documents-Items">
				<style>
					.document-entry-row
					{
						display:flex;
						justify-content: space-between;
					}
					.document-entry
					{
						border-top: 1px solid var(--bulma-border);
						border-bottom: 1px solid var(--bulma-border);
					}
					.document-status
					{
						margin-right: 10vw;
					}
				</style>
				<div style="margin-bottom: 10px; font-weight: bold; color: white; margin-left: 10px; margin-top: 10px;">Test Forms to Create:</div>
				{~TS:TestInstanceWizard-Tab-Documents-Item:Record~}
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4 document-entry">
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div class="field">
						<label class="label block" for="DocumentCreate-Entry-Name">Document Name</label>
						<div class="control">
							<input 
								id="DocumentCreate-Entry-Name-{~D:Record.Index~}" 
								class="input" 
								type="text" 
								placeholder="Enter a name for the Document..."
								autocomplete="off"
								value="{~D:Record.Name~}"
								onChange="_Pict.views.TestInstanceWizard.updateDocumentName({~D:Record.Index~})"
							/>
						</div>
					</div>
					<div class="document-entry-row is-size-7">
						<span>
							<b>Document Type:</b> {~D:Record.Type~}
						</span>
					</div>
					<div class="is-size-7">
						<b>Attached Tests:</b>
					</div>
					<div class="is-size-7">
						{~TS:TestInstanceWizard-Tab-Attached-Test-Item:Record.Tests~}
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Attached-Test-Item',
			Template: /*html*/`{~D:Record.Hash~} {~D:Record.Name~} <br />`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'TestInstanceWizard',
			TemplateHash: 'TestInstanceWizard-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'TestInstanceWizard-Content',
			TemplateHash: 'TestInstanceWizard-Content',
			DestinationAddress: '#HeadlightPanels-TestInstanceWizard-Content',
			RenderType: 'replace',
		},
	],
};
